import { render } from "./DownloadFileCellRenderer.vue?vue&type=template&id=6d8ddfab"
import script from "./DownloadFileCellRenderer.vue?vue&type=script&lang=js"
export * from "./DownloadFileCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__